<template>
  <div class="h-full">
    <slot name="page">
      <div class="h-full o-hidden p-b-10" style="background-color: #f5f7f9">
        <div class="h-full relative">
          <div class="bg-white" style="height: 64px" v-if="hasNav">
            <slot name="navigation">
              <div class="w-full h-full flex a-center relative o-hidden">
                <div class="w-full text-center fs-16 bold"
                     style="position: absolute;height: 64px;line-height: 64px;z-index: 1"
                     v-if="navTitle">
                  {{navTitle}}
                </div>
                <div class="p-h-30 relative" style="z-index: 2">
                  <div class="flex a-center backStyle" style="width: 100px;cursor: pointer"
                       v-if="hasBack">
                    <menu-buttom :picdata="getMenuByindex(24)" @menuitemclick="goback"
                                 content="返回"></menu-buttom>
                  </div>
                  <slot name="nav-left"></slot>
                </div>
                <div class="flex-1 ">
                </div>
                <div class="p-h-30 relative" style="z-index: 2">
                  <slot name="nav-right"></slot>
                </div>
              </div>
            </slot>
          </div>

          <slot name="content">
            <div :style="{height: getContentHeight,paddingTop:gettopHeight}" class="o-hidden m-t-10">
              <div class="bg-white" style="height: 100%">
                <slot></slot>
              </div>
            </div>
          </slot>
        </div>
      </div>
    </slot>
  </div>
</template>

<script>
import MenuButtom from './MenuButtom'
import {getMenuPic} from '../../config/menulist'

export default {
  name: 'BasePageComponent',
  components: {MenuButtom},
  props: {
    hasNav: {
      type: Boolean,
      default: true
    },
    navTitle: {
      type: String,
      default: ''
    },
    hasBack: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {}
  },
  computed: {
    getContentHeight () {
      if (this.hasNav) {
        return 'calc(100% - 57px)'
      } else {
        return '100%'
      }
    },
    gettopHeight () {
      if (this.hasNav) {
        return '10px'
      } else {
        return '0'
      }
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {

    },
    getMenuByindex (index) {
      return getMenuPic(index)
    },
    goback () {
      this.$emit('backClick')
    }
  }
}
</script>

<style lang="scss" scoped>
  .backStyle:hover {
    color: #3b80ff;

    .selected {
      display: block;
    }

    .unselected {
      display: none;
    }
  }

  .backStyle {
    .selected {
      display: none;
    }

    .unselected {
      display: block;
    }
  }
</style>
